import { formatArticlesCount } from '@/features/media-authors/utils/format-articles-count';

type MediaAuthorArticlesHeaderProps = {
  readonly articlesCount: number;
};

/**
 * Section title with published articles count badge.
 */
export function MediaAuthorArticlesHeader({ articlesCount }: MediaAuthorArticlesHeaderProps) {
  return (
    <div className="mb-4 flex flex-wrap items-center gap-2 md:mb-6">
      <h2 className="text-xl font-black uppercase leading-[1.2] tracking-[-0.02em] text-[#1B1D22] sm:text-2xl">
        Статьи автора
      </h2>
      <span className="shrink-0 rounded-full bg-[#F2F3F7] px-3 py-1 text-sm font-medium leading-none text-[#6E7384]">
        {formatArticlesCount(articlesCount)}
      </span>
    </div>
  );
}
